// booking/state/booking.storage.ts
import type { TicketQuantities, Session } from '../types/booking'
import { CustomerFormFields } from '../stages/CustomerDetails/types'

export const STORAGE_KEYS = {
  cartId: 'cartId',
  stage: 'stage',
  numbers: 'numbers',
  session: 'session',
  customerData: 'customerData',
  vouchers: 'book.vouchers',
  discount: 'book.discount',
} as const

export function readString(key: string): string | null {
  return sessionStorage.getItem(key)
}

export function writeString(key: string, value: string) {
  sessionStorage.setItem(key, value)
}

export function readJson<T>(key: string): T | null {
  const raw = sessionStorage.getItem(key)
  if (!raw) return null
  try {
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

export function writeJson(key: string, value: unknown) {
  sessionStorage.setItem(key, JSON.stringify(value))
}

export function clearBookingStorage() {
  sessionStorage.removeItem(STORAGE_KEYS.cartId)
  sessionStorage.removeItem(STORAGE_KEYS.stage)
  sessionStorage.removeItem(STORAGE_KEYS.numbers)
  sessionStorage.removeItem(STORAGE_KEYS.session)
  sessionStorage.removeItem(STORAGE_KEYS.customerData)
  sessionStorage.removeItem(STORAGE_KEYS.vouchers)
  sessionStorage.removeItem(STORAGE_KEYS.discount)
}

// Typed convenience reads
//export const readPlan = () => readJson<Plan>(STORAGE_KEYS.plan)
export const readNumbers = () => readJson<TicketQuantities>(STORAGE_KEYS.numbers)
export const readSession = () => readJson<Session>(STORAGE_KEYS.session)
export const readCustomerData = () => readJson<CustomerFormFields>(STORAGE_KEYS.customerData)
